import styled, { createGlobalStyle } from 'styled-components';

import { mediaMin } from '@spa/shared/theme';
import { Box } from '@spa/shared/components/Modal/styles';

export const ModalGlobalStyle = createGlobalStyle`
  .energy-certification {
    ${Box} {
      width: 560px;
      overflow-y: auto;

      ${mediaMin.mediumBreakpoint`
        height: 100%;
        width: 100%;
        overflow: auto;
      `}
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: ${props => props.theme.space(4)};
`;

export const CertificatesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(2)};
`;

export const CertificateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(2)};
`;

export const CertificateRow = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 28px;
`;

export const Separator = styled.hr`
  border: 0;
  border-top: ${props => `1px solid ${props.theme.energyCertification.separator.borderColor}`};
`;

export const Title = styled.h3`
  font-size: ${props => props.theme.rem(16)};
  line-height: 20px;
  font-weight: 600;
  color: ${props => props.theme.energyCertification.modal.textColor};
`;

export const Text = styled.p`
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(20)};
  color: ${props => props.theme.energyCertification.modal.textColor};
`;

export const SecondaryText = styled(Text)`
  color: ${props => props.theme.energyCertification.modal.secondaryTextColor};
`;
